import _ from 'lodash'
import { mapGetters } from 'vuex'
import debounce from 'components/shared/mixins/debounce'
import { mapOrderTypeToSortValue, orderTypes } from 'store/shared/sorterOptions'
import { isContentListing } from '@/router'

export default {
    mixins: [debounce],
    computed: {
        ...mapGetters({
            searchQuery: 'Search/searchQuery',
            viewType: 'Search/getViewType',
            searchComponentKey: 'Search/getSearchComponentKey'
        })
    },
    methods: {
        goToAllItemsList () {
            if (isContentListing(this.$route)) {
                return false
            }
            if (this.searchPhrase === '' || this.searchPhrase === null) {
                this.$router.push({ 'name': 'all-packages-all-content' })
            } else {
                this.setQuery(this.searchPhrase)
            }
        },
        onClearSearch () {
            this.$store.dispatch('Search/setQuery', null)
            this.searchPhrase = null
        },
        setQuery (query) {
            if (query !== null && query !== '') {
                if (!isContentListing(this.$route)) {
                    this.$router.push({ name: 'all-packages-all-content' })
                }
                if (this.viewType === 'all') {
                    this.$store.dispatch('Search/setSort', mapOrderTypeToSortValue(orderTypes.RELEVANCE))
                }
            }
            this.$store.dispatch('Search/setQuery', query)
        },
        debouncedSetQuery: _.debounce(function (query) {
            this.setQuery(query)
        }, 500)
    },
    data () {
        return {
            searchPhrase: this.searchQuery
        }
    },
    watch: {
        searchPhrase (searchPhrase) {
            this.debouncedSetQuery(searchPhrase)
        },
        searchComponentKey () {
            this.searchPhrase = this.searchQuery
        }
    },
    mounted () {
        this.searchPhrase = this.searchQuery
    }
}
